import {bleskAuthRedirectStore, bleskAuthStore} from '@blesk-frontend/auth';
import {Loader, Page} from '@blesk-frontend/ui';
import {useEffect} from 'react';

import {useAppPlatform} from '@/hooks';
import {updateExtensionToken} from '@/libs';
import {sendEvent} from '@/libs/analytics';
import {Route} from '@/routes/_auth/auth/callback';

export const AuthCallbackPage = () => {
  const {updateToken} = bleskAuthStore();
  const {redirectUrl} = bleskAuthRedirectStore();
  const {accessToken = null, isSignUp, isAdmin} = Route.useSearch();
  const navigate = Route.useNavigate();
  const {setWindowsStatus} = useAppPlatform();

  // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  useEffect(() => {
    (async () => {
      updateToken(accessToken ?? null, isAdmin);
      setWindowsStatus('loading');

      // TODO: логика дублируется на странице AuthVerifyPage. Возможно имеет смысл вынести общую логику
      if (isSignUp) {
        sendEvent('auth/complete');
      }

      const inviteCode = sessionStorage.getItem('inviteCode');

      if (inviteCode) {
        navigate({
          to: '/auth/invite',
          search: {code: inviteCode, accessToken: undefined, staffId: undefined},
        });
      } else if (redirectUrl === 'extension' || redirectUrl?.includes('/guides/extension')) {
        await updateExtensionToken(accessToken);
        window.close();
      } else if (redirectUrl === 'app') {
        navigate({to: '/auth/app'});
      } else {
        await updateExtensionToken(accessToken);
        navigate({to: '/', replace: true});
      }
    })();
  }, [accessToken, isAdmin, isSignUp, navigate, redirectUrl, updateToken]);

  return (
    <Page className="flex flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-center text-title-h1">Авторизация</h1>

      {redirectUrl === 'app' ? (
        <div className="text-paragraph-sm text-text-secondary">
          Авторизация выполнена, можно закрыть это окно.
        </div>
      ) : (
        <div className="text-text-secondary">
          <Loader size={24} />
        </div>
      )}
    </Page>
  );
};
